export default __webpack_public_path__ + "static/Blockchain-Consulting-6de6a50de1c7e4bae072ddc97578c89b.webp";